// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"cb6ab604","98":"00acbc99","252":"00acbc99"}[chunkId] + ".css";
};